const salaryRange = [
  {
    name: "No salary",
    value: "NO_SALARY",
  },
  {
    name: "Below basic",
    value: "BELOW_BASIC",
  },
  {
    name: "Basic",
    value: "BASIC",
  },
  {
    name: "550-700",
    value: "S550_700",
  },
  {
    name: "701-900",
    value: "S701_900",
  },
  {
    name: "901-1200",
    value: "S900_1200",
  },
  {
    name: "1200+",
    value: "S1200_PLUS",
  },
  {
    name: "Other",
    value: "OTHER",
  },
];

export default salaryRange;
